import EImageWithFallback from '@/components/everridge/EImageWithFallback';
import Cancel_01_Icon from '@/components/icons/Cancel_01_Icon';
import ImageIconSolid from '@/components/icons/ImageIconSolid';
import { Button } from '@/components/ui/button';
import {
	Dialog,
	DialogContent,
	DialogTitle,
	DialogDescription,
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';
import { FC, useState } from 'react';

type Props = {
	selectedIndex: number;
	data: string[];
	onClose: () => void;
};

const ApartmentDetailsPhotoReview: FC<Props> = ({
	selectedIndex,
	data,
	onClose,
}) => {
	const [isOpen, setIsOpen] = useState(true);
	const [currentIndex, setCurrentIndex] = useState(selectedIndex);

	const handleClose = () => {
		setIsOpen(false);
		setTimeout(onClose, 300);
	};

	return (
		<Dialog open={isOpen}>
			<DialogTitle />
			<DialogDescription />
			<DialogContent
				className='w-full h-full justify-center bg-transparent border-none shadow-none'
			>
				<div className='h-screen py-20 flex flex-col justify-center items-center gap-10 select-none'>
					<Button
						variant='outline'
						size='icon'
						onClick={handleClose}>
						<Cancel_01_Icon />
					</Button>
					<EImageWithFallback
						src={data[currentIndex]}
						fallbackSVG={ImageIconSolid}
						containerClassName='w-[840px] h-2/3 my-auto rounded-2.5xl shadow-custom overflow-hidden'
						imageClassName='object-contain'
					/>
					<div className='flex gap-2'>
						{data.map((url, index) => (
							<div
								key={index}
								className={cn(
									'relative size-16 rounded-semi-xl group cursor-pointer overflow-hidden transition-all',
									currentIndex === index
										? 'outline-2 outline-popover-10 shadow-toast'
										: '',
								)}
								onClick={() => setCurrentIndex(index)}>
								<EImageWithFallback
									src={url}
									fallbackSVG={ImageIconSolid}
								/>
								<div className='absolute inset-0 flex items-center justify-center bg-popover-1000/20 active:bg-popover-1000/40 opacity-0 group-hover:opacity-100 transition-opacity' />
							</div>
						))}
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default ApartmentDetailsPhotoReview;
